import { defineMessages, MessageDescriptor } from 'react-intl';

const messages: Record<string, MessageDescriptor> = defineMessages({
	channels: {
		id: 'sidebar.channels',
		defaultMessage: 'Channels'
	},
	games: {
		id: 'sidebar.games',
		defaultMessage: 'Games'
	},
	dailyTests: {
		id: 'sidebar.dailyTests',
		defaultMessage: 'Daily Tests'
	},
	football: {
		id: 'sidebar.football',
		defaultMessage: 'Football'
	},
	golf: {
		id: 'sidebar.golf',
		defaultMessage: 'Golf'
	},
	f1: {
		id: 'sidebar.f1',
		defaultMessage: 'F1'
	},
	americanfootball: {
		id: 'sidebar.americanfootball',
		defaultMessage: 'US Football'
	},
	cricket: {
		id: 'sidebar.cricket',
		defaultMessage: 'Cricket'
	},
	baseball: {
		id: 'sidebar.baseball',
		defaultMessage: 'Baseball'
	},
	basketball: {
		id: 'sidebar.basketball',
		defaultMessage: 'Basketball'
	},
	recapSchedule: {
		id: 'sidebar.recapSchedule',
		defaultMessage: 'Recap Schedule'
	},
	ukFootballSchedule: {
		id: 'sidebar.ukFootballSchedule',
		defaultMessage: 'UK Football'
	},
	germanFootballSchedule: {
		id: 'sidebar.germanFootballSchedule',
		defaultMessage: 'German Football'
	},
	italianFootballSchedule: {
		id: 'sidebar.italianFootballSchedule',
		defaultMessage: 'Italian Football'
	},
	f1Schedule: {
		id: 'sidebar.f1Schedule',
		defaultMessage: 'F1'
	},
	cricketSchedule: {
		id: 'sidebar.cricketSchedule',
		defaultMessage: 'Cricket'
	},
	peacockLemFeed: {
		id: 'sidebar.peacockLemFeed',
		defaultMessage: 'LEM Feed'
	}
});

export default messages;
